import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  Button,
  Form,
  Loader,
  Container,
  Segment
} from 'semantic-ui-react'
import { path } from 'ramda'
import { Link } from 'react-router-dom'
import Alert from 'Components/Alert'

import UserActions from 'Redux/UserRedux'

class UserAddEdit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      id: Number(path(['params', 'userId'], this.props.match)),
      name: '',
      email: '',
      role: 'editor',
      teamId: null
    }
  }

  componentDidMount () {
    this.state.id && this.props.usersShowRequest(this.state.id)
    const teamId = path(['params', 'teamId'], this.props.match)
    this.setState({ teamId: Number(teamId) })
  }

  componentDidUpdate (prevProps) {
    if (this.props.createData !== prevProps.createData) {
      this.props.history.push(`/teams/${this.state.teamId}/users`)
    }
  }
  componentWillReceiveProps (nextProps) {
    if (this.props.user !== nextProps.user &&
        nextProps.user) {
      this.setState({
        id: nextProps.user.id,
        name: nextProps.user.name || '',
        email: nextProps.user.email,
        role: nextProps.user.role
      })
    }
  }

  onChange = (e, data) => {
    const { name, value } = e.target
    this.setState({[name]: value})
  }

  onRoleChange = (_, {name, value}) => {
    this.setState({[name]: value})
  }

  onSave = () => {
    if (this.state.id) {
      this.props.usersUpdateRequest(this.state.id, {
        name: this.state.name,
        email: this.state.email,
        role: this.state.role
      })
    } else {
      this.props.usersCreateRequest({
        name: this.state.name,
        email: this.state.email,
        role: this.state.role,
        teamId: this.state.teamId
      })
    }
  }

  render () {
    return (
      <Container style={{marginTop: '20px'}}>
        <Segment>
          <Alert color='red' messages={this.props.error} />
          <Form>
            <Loader active={this.props.fetching} />
            <Form.Field>
              <label>Name</label>
              <input
                type='text'
                name='name'
                placeholder='Name'
                value={this.state.name}
                onChange={this.onChange}
              />
            </Form.Field>
            <Form.Field>
              <label>Email</label>
              <input
                type='text'
                name='email'
                placeholder='Email'
                value={this.state.email}
                onChange={this.onChange}
              />
            </Form.Field>
            <Button
              primary
              type='submit'
              onClick={this.onSave}>Submit</Button>
            <Link to={`/teams/${this.state.teamId}/users`}>
              <Button basic>Back</Button>
            </Link>
          </Form>
        </Segment>
      </Container>
    )
  }
}

const mapStateToProps = (state) => ({
  error: state.users.updateError || state.users.createError,
  user: state.users.showData,
  fetching: state.users.showFetching || state.users.updateFetching,
  createData: state.users.createData,
  userData: state.auth.userData,
})

const mapDispatchToProps = (dispatch) => ({
  usersShowRequest: (id) => dispatch(UserActions.usersShowRequest(id)),
  usersUpdateRequest: (id, updateParams) =>
    dispatch(UserActions.usersUpdateRequest(id, updateParams)),
  usersCreateRequest: (updateParams) =>
    dispatch(UserActions.usersCreateRequest(updateParams))
})

export default connect(mapStateToProps, mapDispatchToProps)(UserAddEdit)



// WEBPACK FOOTER //
// ./src/Pages/Users/AddEdit.js